<script setup lang="ts">
import type { ISteps as IProps } from './Step.types'
defineProps<IProps>()
</script>

<template>
  <div
    v-for="(step, index) in steps"
    :key="index"
    class="stepWrapper"
  >
    <Step v-bind="step" />
    <img
      v-if="step.isArrow"
      src="/icons/step/arrow.svg"
      class="stepArrow"
    >
  </div>
</template>

<style lang="scss" scoped>
.stepWrapper {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.stepArrow {
  width: 1.6rem;
  margin-right: 0.8rem;
}
</style>
